module.exports = __webpack_public_path__ + "fonts/Inter-Regular.851660f9.ttf";